import { lazy } from 'react';

export const WardrobePage = lazy(() =>
  import('@/pages/wardrobe/main/WardrobePage').then(m => ({
    default: m.WardrobePage,
  }))
);

export const WardrobeFavoritesPage = lazy(() =>
  import('@/pages/wardrobe/favorites/WardrobeFavoritesPage').then(m => ({
    default: m.WardrobeFavoritesPage,
  }))
);

export const WardrobeMyItemsPage = lazy(() =>
  import('@/pages/wardrobe/my-items/WardrobeMyItemsPage').then(m => ({
    default: m.WardrobeMyItemsPage,
  }))
);

export const WardrobeOutfitsPage = lazy(() =>
  import('@/pages/wardrobe/outfits/WardrobeOutfitsPage').then(m => ({
    default: m.WardrobeOutfitsPage,
  }))
);

export const WardrobeItemsReviewPage = lazy(() =>
  import('@/pages/WardrobePage/WardrobeItemsReviewPage').then(m => ({
    default: m.WardrobeItemsReviewPage,
  }))
);

export const WardrobeMyItemsAddPage = lazy(() =>
  import('@/pages/wardrobe/add/WardrobeMyItemsAddPage').then(m => ({
    default: m.WardrobeMyItemsAddPage,
  }))
);

export const WardrobeItemEditPage = lazy(() =>
  import('@/pages/wardrobe/edit/WardrobeItemEditPage').then(m => ({
    default: m.WardrobeItemEditPage,
  }))
);
